import React, { useEffect, useState } from "react";
import "../assets/css/style.css";
import { Box, Divider, IconButton, Tooltip, Typography } from "@mui/material";
import { createHeading, createMessage, getIcon } from "../manager/cardManager";
import { useNavigate } from "react-router-dom";
import {
  markNotificationAsRead,
  poChangeApproval,
  priceChangeApproval,
  sendPOChangeApprovalEmail,
  sendPriceChangeApprovalEmail,
} from "../services/dataService";
import { AccessTime, Circle, Close, Done } from "@mui/icons-material";
import { toast } from "react-toastify";
import { impexDateFormat } from "../manager/dateManager";

function ToDoCard({ todo }) {
  const navigate = useNavigate();
  const [todoTask, setTodoTask] = useState(null);

  const openPo = () => {
    if (todo.ModuleName === "Purchase Order") {
      if (todo.SubModule === "Price Changed") {
        navigate(`/impex/purchase-orders/${todo.RedirectId}/price-changed`);
      } else if (todo.SubModule === "PO Changed") {
        navigate(`/impex/purchase-orders/${todo.RedirectId}/po-changed`);
      } else {
        navigate(`/impex/purchase-orders/${todo.RedirectId}`);
      }
    } else if (todo.SubModule === "Invoice Generated") {
      navigate(`/impex/invoices/${todo.RedirectId}`);
    }
  };

  useEffect(() => {
    setTodoTask(todo);
  }, [todo]);

  const readNotification = async (todo) => {
    try {
      if (todo.isRead === 0) {
        await markNotificationAsRead(todo.ID);
        setTodoTask(
          todoTask.map((item) => {
            if (item.ID === todo.ID) {
              return {
                ...item,
                isRead: 1,
              };
            }
            return item;
          })
        );
      }
    } catch (error) {}
  };

  const sendPriceApproval = async (status) => {
    try {
      await priceChangeApproval(status, todo.RequestIdentifier);
      await sendPriceChangeApprovalEmail(todo.RequestIdentifier);
      if (status === true) {
        toast.success("Price change request accepted");
      } else if (status === false) {
        toast.error("Price change request rejected");
      }
    } catch (error) {}
  };

  const sendPOApproval = async (status) => {
    try {
      await poChangeApproval(status, todo.RequestIdentifier);
      await sendPOChangeApprovalEmail(todo.RequestIdentifier);
      if (status === true) {
        toast.success("PO Quantity change request accepted");
      } else if (status === false) {
        toast.error("PO Quantity change request rejected");
      }
    } catch (error) {}
  };

  return (
    <>
      <Box
        sx={{
          pt: 0.5,
          pb: 2,
          pl: 2,
          pr: 1,
          margin: "5px",
          borderRadius: 2,
          bgcolor: "white",
          cursor: "pointer",
        }}
        onClick={() => {
          openPo();
          readNotification(todo);
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            component="p"
            fontWeight={400}
            fontSize="13px"
            onClick={() => {
              openPo();
              readNotification(todo);
            }}
          >
            {createHeading(todo)}
          </Typography>
          {todo.isRead === 0 && (
            <Circle
              fontSize="1px !important"
              color="#0050ff"
              sx={{
                height: "8px",
                width: "8px",
                m: 2,
                color: "#0050ff",
                boxShadow: "0px 0px 20px #0050ff",
              }}
            />
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            flex: 1,
          }}
        >
          {getIcon(todo,"todo")}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              pl: 1,
              flex: 0.8,
            }}
          >
            <Typography component="p" fontWeight={600} fontSize={13} onClick={openPo}>
              {todo.Header ? todo.Header : "-"}
            </Typography>
            <Typography component="p" fontSize={12} onClick={openPo}  >
              {createMessage(todo)}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                mt: 0.5,
                display: "flex",
                alignItems: "center",
                color: "text.disabled",
                fontSize:"10px"
              }}
            >
              <AccessTime
                fontSize="16px"
                sx={{
                  marginRight: 1,
                }}
              />
              {impexDateFormat(todo.CreatedDate)}
            </Typography>
          </Box>
        </Box>
        {["Price Changed", "PO Changed"].includes(todo.SubModule) && 
        (todo.Status === null) &&
        (
          <Box sx={{ textAlign: "right", pr: 1 }}>
            <Tooltip title="Accept">
              <IconButton
                sx={{ mr: 3 }}
                onClick={() => {
                  if (todo.SubModule === "Price Changed") {
                    sendPriceApproval(true);
                  } else if (todo.SubModule === "PO Changed") {
                    sendPOApproval(true);
                  }
                }}
              >
                <Done fontSize="small" sx={{ color: "green" }} />
              </IconButton>
            </Tooltip>

            <Tooltip title="Reject">
              <IconButton
                sx={{ mr: 3 }}
                onClick={() => {
                  if (todo.SubModule === "Price Changed") {
                    sendPriceApproval(false);
                  } else if (todo.SubModule === "PO Changed") {
                    sendPOApproval(false);
                  }
                }}
              >
                <Close fontSize="small" sx={{ color: "#BD3039" }} />
              </IconButton>
            </Tooltip>
          </Box>
        )}
      </Box>
      <Divider></Divider>
    </>
  );
}
export default ToDoCard;
